export const mockOperationAreaRows = [
  {
    id: 1,
    nurse: "Sinerji Bilişim",
    operationDate: "22.05.2025",
    operationTime: "18:00",
    operationName: "Apse İşlemleri",
  }
];